/**
 * Count-up for trust banner: 0 → … → N with k / M formatting, optional + at end.
 * Starts once when the block is fully in view (IntersectionObserver only).
 */
(function () {
  'use strict';

  function parseTargetText(raw) {
    if (raw == null || raw === '') return 1000000;
    var str = String(raw)
      .trim()
      .toLowerCase()
      .replace(/,/g, '');
    if (!str) return 1000000;
    str = str.replace(/\+$/, '');
    var m = str.match(/^([\d.]+)\s*m$/);
    if (m) {
      var mv = parseFloat(m[1]);
      if (!isNaN(mv) && mv >= 0) return Math.round(mv * 1000000);
    }
    var k = str.match(/^([\d.]+)\s*k$/);
    if (k) {
      var kv = parseFloat(k[1]);
      if (!isNaN(kv) && kv >= 0) return Math.round(kv * 1000);
    }
    var digits = parseInt(str.replace(/[^\d]/g, ''), 10);
    if (!isNaN(digits) && digits >= 0) return digits;
    return 1000000;
  }

  function formatTrustCount(n) {
    n = Math.max(0, Math.floor(Number(n)));
    if (n >= 1000000) {
      var m = n / 1000000;
      if (Math.abs(m - Math.round(m)) < 0.001) {
        return String(Math.round(m)) + 'M';
      }
      var rounded = Math.round(m * 10) / 10;
      var s = rounded % 1 === 0 ? String(Math.round(rounded)) : rounded.toFixed(1);
      return s.replace(/\.0$/, '') + 'M';
    }
    if (n >= 1000) {
      return Math.floor(n / 1000) + 'k';
    }
    return String(n);
  }

  /** Whole element visible in viewport, or max height when taller than screen. */
  function isFullyInView(entry) {
    if (!entry || !entry.isIntersecting) return false;
    if (entry.intersectionRatio >= 0.985) return true;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var brH = entry.boundingClientRect.height;
    if (brH < 1 || vh < 1) return false;
    if (brH > vh * 0.92) {
      return entry.intersectionRect.height >= vh * 0.9;
    }
    return false;
  }

  function initEl(root) {
    if (root.getAttribute('data-trust-count-initialized') === '1') return;
    root.setAttribute('data-trust-count-initialized', '1');

    var numEl = root.querySelector('.trust-social-proof__count-num');
    if (!numEl) return;

    var rawText = root.getAttribute('data-target-text');
    var target = parseTargetText(rawText);
    if (isNaN(target) || target < 0) target = 0;

    var dur = parseInt(root.getAttribute('data-duration'), 10);
    if (isNaN(dur) || dur < 200) dur = 2000;

    var showPlus = root.getAttribute('data-show-plus') !== 'false';
    var suffix = root.getAttribute('data-suffix') || '';
    var appendPlus = showPlus && target >= 1000000;

    function announceFinal() {
      var s = formatTrustCount(target);
      if (appendPlus) s += '+';
      var full = (s + (suffix ? ' ' + suffix : '')).trim();
      root.setAttribute('aria-label', full);
    }

    function finish() {
      var s = formatTrustCount(target);
      if (appendPlus) s += '+';
      numEl.textContent = s;
      announceFinal();
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finish();
      return;
    }

    root.setAttribute('aria-label', '');

    var animStarted = false;
    var io = null;
    var runId = 0;

    function easeOutQuad(t) {
      return 1 - (1 - t) * (1 - t);
    }

    function startAnim() {
      if (animStarted) return;
      animStarted = true;

      if (io) {
        try {
          io.disconnect();
        } catch (e) {}
        io = null;
      }

      runId += 1;
      var myRun = runId;
      var start = null;

      function tick(ts) {
        if (myRun !== runId) return;

        if (start === null) start = ts;
        var elapsed = ts - start;
        var p = Math.min(1, elapsed / dur);
        var eased = easeOutQuad(p);
        var val = Math.floor(target * eased);
        numEl.textContent = formatTrustCount(val);

        if (p < 1) {
          requestAnimationFrame(tick);
        } else {
          if (myRun !== runId) return;
          finish();
        }
      }

      requestAnimationFrame(tick);
    }

    if (typeof IntersectionObserver !== 'function') {
      startAnim();
      return;
    }

    var thresholds = [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.85, 0.9, 0.92, 0.94, 0.96, 0.98, 1];

    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (animStarted) return;
          if (!isFullyInView(entry)) return;
          startAnim();
        });
      },
      { root: null, rootMargin: '0px', threshold: thresholds }
    );
    io.observe(root);
  }

  function scan() {
    document.querySelectorAll('[data-trust-count-anim]').forEach(initEl);
  }

  if (window.__TSC_LOADED) {
    scan();
    return;
  }
  window.__TSC_LOADED = true;
  window.__TSC_SCAN = scan;

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);

  if (document.readyState !== 'loading') {
    scan();
  }
})();
